import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import ClientInvoiceHeading from 'ts/common/components/invoice/ClientInvoiceHeading';
import { isPaymentAvailable } from 'ts/common/components/invoice/helpers';
import { type ClientPaymentOption } from 'client_react/common/components/ClientPaymentOptions';
import LegacyInvoicePaymentForm from 'client_react/invoice/components/LegacyInvoicePaymentForm';
import StripeInvoicePaymentForm from 'client_react/invoice/components/StripeInvoicePaymentForm';

const InvoicePaymentPage: React.FC = () => {
    const { invoice } = useOutletContext<{ invoice: SpApi.Client.IInvoice }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (isPaymentAvailable(invoice)) {
            scrollTo(0, 0);
        } else {
            navigate(`/invoice/${invoice.publicId}`);
        }
    }, [invoice, navigate]);

    const [paymentAmountType, setPaymentAmountType] = useState<ClientPaymentOption>('full');
    const [customAmount, setCustomAmount] = useState<number>(0);

    return (
        <Box maxW="1000px" mx="auto" as="main">
            <ClientInvoiceHeading invoice={invoice} />
            {invoice.paymentGatewayType === 'sp_pay' ||
            invoice.paymentGatewayType === 'stripe_standard' ? (
                <StripeInvoicePaymentForm
                    customAmount={customAmount}
                    paymentAmountType={paymentAmountType}
                    setCustomAmount={setCustomAmount}
                    setPaymentAmountType={setPaymentAmountType}
                />
            ) : (
                <LegacyInvoicePaymentForm
                    customAmount={customAmount}
                    paymentAmountType={paymentAmountType}
                    setCustomAmount={setCustomAmount}
                    setPaymentAmountType={setPaymentAmountType}
                />
            )}
        </Box>
    );
};

export default InvoicePaymentPage;
